 export const skillsData = [
    'HTML',
    'Javascript',
    'CSS',
    'React',
    'Redux',
    'mySQL',
    'Python',
    'nodejs',
    'git'
]
